module.exports = __webpack_public_path__ + "img/avatar.37c3ea6b.png";